
import { Button, Col, Row } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

import { ITenant } from '../../reducers';

interface IProps {
  index: number;
  deletePreviousTenant: (index: number) => void;
  previousTenantInfos: ITenant;
  changePreviousTenantInfos: (e: any, index: number) => void;
}

const PreviousTenantInfos = (props: IProps) => {
  const { register } = useFormContext();
  return (
    <div>
      <div className="d-flex justify-content-between">
        <div>
          <h2 className="order-title">Occupant sortant</h2>
          <p className="p-order">
            Indiquez les informations de l'occupant additionnel pour la prise de rendez-vous de l’état des lieux de sortie
          </p>
        </div>
        <Button className="btn-trash ms-4" onClick={() => props.deletePreviousTenant(props.index)}>
          <i className="bi bi-trash"></i>
        </Button>
      </div>
      <Row className="mt-3">
        <Col className="d-flex flex-column justify-content-between">
          <label className="w-100 add-prop-label ms-2">Prénom</label>
          <input
            className="w-100 add-prop-input"
            type="text"
            {...register(`PTI.${props.index}.firstname`)}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between">
          <label className="w-100 add-prop-label ms-2">Nom</label>
          <input
            className="w-100 add-prop-input"
            type="text"
            {...register(`PTI.${props.index}.name`)}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between">
          <label className="w-100 add-prop-label ms-2">Numéro de téléphone</label>
          <input
            className="w-100 add-prop-input"
            type="tel"
            {...register(`PTI.${props.index}.phone`)}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-between">
          <label className="w-100 add-prop-label ms-2">Adresse email</label>
          <input
            className="w-100 add-prop-input"
            type="email"
            {...register(`PTI.${props.index}.email`)}
          />
        </Col>
      </Row>
    </div>
  );
};

export default PreviousTenantInfos;
